(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5208],{

/***/ 39989:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/downloadable-products",
      function () {
        return __webpack_require__(12458);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 93487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81043);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _svg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69587);
/* harmony import */ var _store_token__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46607);
/* harmony import */ var _api_shop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(65564);
/* harmony import */ var _store_cart__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7597);
/* harmony import */ var _account_module_scss__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(67707);
/* harmony import */ var _account_module_scss__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_account_module_scss__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _store_customer__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(97331);
/* harmony import */ var _hooks_useGlobal__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(76210);
/* harmony import */ var _shared_PageHeader__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(64465);
/* harmony import */ var _store_wishlist__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(84444);
/* harmony import */ var _AccountNavigationMenu__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(81111);
/* harmony import */ var _store_orders_ordersActions__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(64514);




















var AccountLayout = function(param) {
    var children = param.children, breadcrumb = param.breadcrumb, translationsData = param.translationsData, selectedLocale = param.selectedLocale, dbName = param.dbName;
    var selectedRate = (0,_hooks_useGlobal__WEBPACK_IMPORTED_MODULE_11__/* .useGlobal */ .O)().selectedRate;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), links = ref[0], setLinks = ref[1];
    var history = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)();
    var cartToken = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state.cartToken;
    }).cartToken;
    var isDownloadableOrder = !!(0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state.orders.downloadable;
    }).length;
    var customer = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state.customer;
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var baseLinks = [
            {
                id: 1,
                url: "profile",
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_6__/* .Profile */ .NZ, {}),
                title: translationsData.PersonalInformation
            },
            {
                id: 2,
                url: "orders",
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_6__/* .Orders */ .We, {
                    className: (_account_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["historyIcon-svg"])
                }),
                title: translationsData.MyOrders
            }
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(isDownloadableOrder ? [
            {
                id: 3,
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_6__/* .DownloadIcon */ ._8, {}),
                url: "downloadable-products",
                title: translationsData.DownloadableProducts
            }
        ] : []), [
            {
                id: 4,
                url: "addresses",
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_6__/* .Addresses */ .sA, {}),
                title: translationsData.Address
            },
            {
                id: 5,
                url: "logout",
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_6__/* .Logout */ .RD, {}),
                title: translationsData.SignOut
            }
        ]);
        setLinks(baseLinks);
    }, [
        isDownloadableOrder
    ]);
    var logout = function(e) {
        e.preventDefault();
        dispatch((0,_store_customer__WEBPACK_IMPORTED_MODULE_10__/* .setAuth */ .QV)(false));
        dispatch((0,_store_customer__WEBPACK_IMPORTED_MODULE_10__/* .setCustomerGroupID */ .KJ)(1));
        dispatch((0,_store_customer__WEBPACK_IMPORTED_MODULE_10__/* .setToken */ .o4)(""));
        dispatch((0,_store_orders_ordersActions__WEBPACK_IMPORTED_MODULE_16__/* .clearOrders */ .oh)());
        _api_shop__WEBPACK_IMPORTED_MODULE_8__["default"].getCustomerLogoutToken(customer.token).then(function(item) {
            if (item.ok) {
                _api_shop__WEBPACK_IMPORTED_MODULE_8__["default"].getCheckoutCartToken().then(function(res) {
                    if (res.api_token) {
                        dispatch((0,_store_token__WEBPACK_IMPORTED_MODULE_7__/* .AddCartToken */ .y)(res.api_token));
                    }
                });
            }
        });
        dispatch((0,_store_cart__WEBPACK_IMPORTED_MODULE_9__/* .getCartDataMount */ .yU)(cartToken, {
            token: ""
        }, selectedLocale, selectedRate ? selectedRate.code : ""));
        dispatch((0,_store_wishlist__WEBPACK_IMPORTED_MODULE_17__/* .wishListRemoveAllItems */ .XZ)());
        history.push("/");
    };
    var newLinks = links.map(function(link) {
        var classes = classnames__WEBPACK_IMPORTED_MODULE_2___default()((_account_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["account-nav__item"]), history.route.includes(link.url) && (_account_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["account-nav__item--active"]));
        var signOutProps = link.url === "logout" ? {
            onClick: logout,
            className: (_account_module_scss__WEBPACK_IMPORTED_MODULE_14___default().logout)
        } : {};
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
            className: classes,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: "/account/".concat(link.url),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, signOutProps), {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: link.icon
                        }),
                        link.title
                    ]
                }))
            })
        }, link.id);
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_PageHeader__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                dbName: dbName,
                breadcrumb: breadcrumb
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: (_account_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["account-nav__title"]),
                children: translationsData.MyAccount
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_account_module_scss__WEBPACK_IMPORTED_MODULE_14___default().block),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_account_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["account-layout-wrapper"]),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AccountNavigationMenu__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                links: newLinks
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "".concat((_account_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["account-layout"]), " ").concat((_account_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["account-layout-desktop"])),
                                children: children
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AccountLayout);


/***/ }),

/***/ 64465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69587);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _shared_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12820);
/* harmony import */ var _shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_shared_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _schemaorg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91257);








var PageHeader = function(props) {
    var _breadcrumb = props.breadcrumb, breadcrumb = _breadcrumb === void 0 ? [] : _breadcrumb, dbName = props.dbName;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var schema = (0,_schemaorg__WEBPACK_IMPORTED_MODULE_6__/* .schemaPageHeader */ .ed)(dbName, router.asPath, breadcrumb);
    if (breadcrumb.length > 0) {
        var lastIndex = breadcrumb.length - 1;
        breadcrumb = breadcrumb.map(function(item, index) {
            var link;
            if (lastIndex === index) {
                link = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_5___default()), {
                            id: schema.name,
                            type: "application/ld+json",
                            dangerouslySetInnerHTML: {
                                __html: JSON.stringify(schema)
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            className: "".concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["breadcrumb-item"]), " ").concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["breadcrumb-item-active"])),
                            "aria-current": "page",
                            children: item.title
                        })
                    ]
                }, index);
            } else {
                link = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                    className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["breadcrumb-item"]),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: item.url,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: item.title
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_3__/* .ArrowRoundedRight6x9Svg */ .EO, {
                            className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["breadcrumb-arrow"])
                        })
                    ]
                }, index);
            }
            return link;
        });
        breadcrumb = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["page-header__breadcrumb"]),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                "aria-label": "breadcrumb",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                    className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default().breadcrumb),
                    children: breadcrumb
                })
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["page-header"]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "".concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["page-header__container"]), " container"),
            children: breadcrumb
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageHeader);


/***/ }),

/***/ 76193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _shared_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12820);
/* harmony import */ var _shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_shared_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69587);






var Pagination = function(param) {
    var _current = param.current, current = _current === void 0 ? 1 : _current, _siblings = param.siblings, siblings = _siblings === void 0 ? 1 : _siblings, _total = param.total, total = _total === void 0 ? 1 : _total, onPageChange = param.onPageChange;
    var setPage = function(value) {
        if (value < 1 || value > total || value === current) {
            return;
        }
        try {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth"
            });
        } catch (e) {
            window.scrollTo(0, 0);
        }
        if (onPageChange) {
            onPageChange(value);
        }
    };
    var getPages = function() {
        var pages = [];
        var min = Math.max(1, current - siblings - Math.max(0, siblings - total + current));
        var max = Math.min(total, min + siblings * 2);
        for(var i = min; i <= max; i += 1){
            pages.push(i);
        }
        return pages;
    };
    var firstLinkClasses = classnames__WEBPACK_IMPORTED_MODULE_2___default()((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-item"]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-item-disabled"]), current <= 1));
    var lastLinkClasses = classnames__WEBPACK_IMPORTED_MODULE_2___default()((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-item"]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-item-disabled"]), current >= total));
    var pages = getPages().map(function(page, index) {
        var classes = classnames__WEBPACK_IMPORTED_MODULE_2___default()((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-item"]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-item-active"]), page === current));
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
            className: classes,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                type: "button",
                className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-link"]),
                onClick: function() {
                    return setPage(page);
                },
                children: [
                    page,
                    page === current && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["sr-only"]),
                        children: current
                    })
                ]
            })
        }, index);
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
        className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default().pagination),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                className: firstLinkClasses,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    type: "button",
                    className: "".concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-link"]), " ").concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-link--with-arrow"])),
                    "aria-label": "Previous",
                    onClick: function() {
                        return setPage(current - 1);
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_3__/* .ArrowRoundedLeft8x13Svg */ .lb, {
                        className: "".concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-link__arrow"]), " ").concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-link__arrow--left"])),
                        "aria-hidden": "true"
                    })
                })
            }),
            pages,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                className: lastLinkClasses,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    type: "button",
                    className: "".concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-link"]), " ").concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-link--with-arrow"])),
                    "aria-label": "Next",
                    onClick: function() {
                        return setPage(current + 1);
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_3__/* .ArrowRoundedRight8x13Svg */ .pn, {
                        className: "".concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-link__arrow"]), " ").concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-link__arrow--right"])),
                        "aria-hidden": "true"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Pagination);


/***/ }),

/***/ 76210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* reexport safe */ _context_GlobalContext__WEBPACK_IMPORTED_MODULE_0__.b; }
/* harmony export */ });
/* harmony import */ var _context_GlobalContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68912);



/***/ }),

/***/ 12458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ downloadable_products; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./helper.js
var helper = __webpack_require__(63385);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/account/AccountLayout.tsx
var AccountLayout = __webpack_require__(93487);
// EXTERNAL MODULE: ./components/ForCWV/Wrappers/MainLayout.tsx + 32 modules
var MainLayout = __webpack_require__(75947);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(81043);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/account/account.module.scss
var account_module = __webpack_require__(67707);
var account_module_default = /*#__PURE__*/__webpack_require__.n(account_module);
// EXTERNAL MODULE: ./components/shared/Pagination.tsx
var Pagination = __webpack_require__(76193);
// EXTERNAL MODULE: ./svg/index.js
var svg = __webpack_require__(69587);
;// CONCATENATED MODULE: ./components/account/AccountPageDownloadableOrders.tsx










var AccountPageDownloadableOrders = function(param) {
    var dbName = param.dbName, translationsData = param.translationsData;
    var formatDate = function formatDate(date) {
        var cleared = date.split("-");
        var year = cleared[0];
        var month = cleared[1];
        var day = cleared[2].slice(0, 2);
        return day + "/" + month + "/" + year;
    };
    var customer = (0,es/* useSelector */.v9)(function(state) {
        return state.customer;
    });
    var limit = 10;
    var ref = (0,react.useState)(1), page = ref[0], setPage = ref[1];
    var ref1 = (0,react.useState)(true), okStatus = ref1[0], setOkStatus = ref1[1];
    var downloadableOrders = (0,es/* useSelector */.v9)(function(state) {
        return state.orders.downloadable;
    });
    var allLinks = downloadableOrders.flatMap(function(order) {
        return order.items.flatMap(function(item) {
            return item.downloadable_links.map(function(link) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, link), {
                    orderId: order.id,
                    createdAt: order.created_at
                });
            });
        });
    });
    var totalPages = Math.ceil(allLinks.length / limit);
    var paginatedLinks = allLinks.slice((page - 1) * limit, page * limit);
    var ref2 = (0,react.useState)(false), updateRequest = ref2[0], setUpdateRequest = ref2[1];
    var ref3 = (0,react.useState)(null), loaderIdCls = ref3[0], setLoaderIdCls = ref3[1];
    var api_token = (0,es/* useSelector */.v9)(function(state) {
        return state.cartToken.cartToken;
    });
    var handlePageChange = function(page) {
        setPage(page);
    };
    if (!downloadableOrders) return null;
    var orderStatusColor = function(status) {
        switch(status){
            case "closed":
                return "#D71313";
            case "expired":
                return "#4f46e5";
            case "pending":
                return "#f4ce14";
            case "available":
                return "#049901";
            default:
                return "#000";
        }
    };
    var ordersList = paginatedLinks.length > 0 ? paginatedLinks.map(function(dwnLink) {
        var statusIdKey = dwnLink === null || dwnLink === void 0 ? void 0 : dwnLink.status;
        var statusKey = statusIdKey[0].toUpperCase() + statusIdKey.slice(1);
        var dwnBought = dwnLink.download_bought;
        var downloadsQty = dwnLink.download_bought - dwnLink.download_used;
        var downloadAllow = (dwnBought === 0 || downloadsQty > 0) && statusIdKey === "available" && okStatus;
        var loaderClickHandle = function() {
            return setLoaderIdCls(dwnLink.id);
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
            className: (account_module_default()).dwn_tr,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                    className: "".concat((account_module_default()).dwn_column, " ").concat((account_module_default()).dwn_link_column),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/account/orders/".concat(dwnLink.orderId),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: (account_module_default()).order__id,
                            children: "#".concat(dwnLink.orderId)
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                    className: "".concat((account_module_default()).dwn_column, " ").concat(downloadAllow ? (account_module_default()).dwn__active : null),
                    children: downloadAllow ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: dwnLink.product_name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (account_module_default()).download__btn_container,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: translationsData.Download
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: (account_module_default()).download__btn,
                                        onClick: function() {
                                            setOkStatus(false);
                                            setUpdateRequest(!updateRequest);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            target: "_blank",
                                            href: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/api/downloadable-products/download/").concat(dwnLink.id, "?token=").concat(customer.token, "&api_token=").concat(api_token)),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                onClick: loaderClickHandle,
                                                className: (account_module_default()).link_container,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* DownloadCloudIcon */.ND, {})
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: dwnLink.name
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (account_module_default()).disabled__product_name,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: dwnLink.product_name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (account_module_default()).disabled__link_container,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: translationsData.Download
                                    }),
                                    statusIdKey === "available" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: loaderIdCls === dwnLink.id ? "btn-loading" : "",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* DownloadCloudIcon */.ND, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: dwnLink.name
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                    className: (account_module_default()).dwn_column,
                    children: formatDate(dwnLink.createdAt)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                    className: (account_module_default()).dwn_column,
                    style: {
                        color: orderStatusColor(statusIdKey.toLowerCase())
                    },
                    children: translationsData[statusKey]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                    className: (account_module_default()).dwn_column,
                    children: dwnBought === 0 ? translationsData === null || translationsData === void 0 ? void 0 : translationsData.UnlimitedTimes : downloadsQty
                })
            ]
        }, dwnLink.id);
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: (account_module_default()).empty_orders_list,
        children: translationsData.DownloadableListEmpty
    });
    var mobileOrderList = paginatedLinks.length > 0 ? paginatedLinks.map(function(dwnLink, index) {
        var loaderClickHandle = function() {
            return setLoaderIdCls(dwnLink.id);
        };
        var statusIdKey = dwnLink === null || dwnLink === void 0 ? void 0 : dwnLink.status;
        var statusKey = statusIdKey[0].toUpperCase() + statusIdKey.slice(1);
        var dwnBought = dwnLink.download_bought;
        var downloadsQty = dwnLink.download_bought - dwnLink.download_used;
        var downloadAllow = (dwnBought === 0 || downloadsQty > 0) && statusIdKey === "available" && okStatus;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((account_module_default()).card, " ").concat((account_module_default())["order-history-card-mobile"]),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (account_module_default())["order-card-mobile-top-position"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("table", {
                    className: (account_module_default()).mob_dwn_table,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("thead", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                className: (account_module_default()).dwn_first_column,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        className: (account_module_default())["order-card-mobile-title"],
                                        style: {
                                            textTransform: "uppercase"
                                        },
                                        children: translationsData.OrderId
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/account/orders/".concat(dwnLink.orderId),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (account_module_default())["order-id-mobile-href"],
                                                children: "#".concat(dwnLink.orderId)
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        className: (account_module_default())["order-card-mobile-title"],
                                        children: translationsData.Product
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        className: (account_module_default()).downloads_column_mob,
                                        children: downloadAllow ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (account_module_default()).downloads__container,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (account_module_default()).dw__product_name,
                                                    children: dwnLink.product_name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (account_module_default()).download__btn_container,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                            children: translationsData.Download
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            className: (account_module_default()).download__btn,
                                                            onClick: function() {
                                                                return setUpdateRequest(!updateRequest);
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                target: "_blank",
                                                                href: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/api/downloadable-products/download/").concat(dwnLink.id, "?token=").concat(customer.token, "&api_token=").concat(api_token)),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    onClick: loaderClickHandle,
                                                                    className: (account_module_default()).link_container,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* DownloadCloudIcon */.ND, {})
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: dwnLink.name
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (account_module_default()).disabled__product_name,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: dwnLink.product_name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (account_module_default()).disabled__link_container,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                            children: translationsData.Download
                                                        }),
                                                        statusIdKey === "available" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: loaderIdCls === dwnLink.id ? "btn-loading" : "",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* DownloadCloudIcon */.ND, {})
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: dwnLink.name
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        children: translationsData.Date
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: formatDate(dwnLink.createdAt)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        children: translationsData.Status
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        style: {
                                            color: orderStatusColor(statusIdKey.toLowerCase())
                                        },
                                        children: translationsData[statusKey]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        children: translationsData.RemainingDownloads
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        className: (account_module_default()).dwn_column,
                                        children: dwnBought === 0 ? translationsData === null || translationsData === void 0 ? void 0 : translationsData.UnlimitedTimes : downloadsQty
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        }, dwnLink.id);
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: (account_module_default()).empty_orders_list,
        children: translationsData.DownloadableListEmpty
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (account_module_default()).card_desktop,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (account_module_default()).card,
                        children: downloadableOrders.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (account_module_default())["card-table"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    children: translationsData.OrderId
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    children: translationsData.Name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    children: translationsData.Date
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    children: translationsData.Status
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    children: translationsData.RemainingDownloads
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                        children: ordersList
                                    })
                                ]
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (account_module_default()).empty_orders_list,
                            children: translationsData.DownloadableListEmpty
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (account_module_default())["card-footer"],
                        children: totalPages > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                            current: page,
                            total: totalPages,
                            onPageChange: handlePageChange
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (account_module_default()).card_mobile,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (account_module_default())["orders-page-mobile"],
                        children: mobileOrderList
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (account_module_default())["card-footer"],
                        children: totalPages > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                            current: page,
                            total: totalPages,
                            onPageChange: handlePageChange
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var account_AccountPageDownloadableOrders = (AccountPageDownloadableOrders);

;// CONCATENATED MODULE: ./pages/account/downloadable-products.tsx











var DownloadableProducts = function(pageProps) {
    var dbName = pageProps.dbName, selectedLocale = pageProps.selectedLocale, translationsData = pageProps.translationsData, breadcrumb = pageProps.breadcrumb, defaultLangCode = pageProps.defaultLangCode, locales = pageProps.locales;
    var customer = (0,es/* useSelector */.v9)(function(state) {
        return state.customer;
    });
    var router = (0,next_router.useRouter)();
    var meta_title = "My Personal Account";
    var meta_description = "My Personal Account for ".concat(dbName, " website ");
    var meta_keywords = "";
    var meta_url = (0,helper/* domainUrl */.HJ)("".concat(dbName).concat(router.locale !== "catchAll" && router.locale !== defaultLangCode ? "/" + selectedLocale : "").concat(router.asPath));
    (0,react.useEffect)(function() {
        if (!customer.token && !customer.authenticated) {
            router.push("/").then(function(r) {
                return r;
            });
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLayout/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pageProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                            children: meta_title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "title",
                            content: meta_title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "description",
                            content: meta_description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "keywords",
                            content: meta_keywords
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "generator",
                            content: "Zegashop.com"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "twitter:description",
                            content: meta_description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "twitter:title",
                            content: meta_title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:description",
                            content: meta_description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:title",
                            content: meta_title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:keywords",
                            content: meta_keywords
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:url",
                            content: meta_url
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:locale",
                            content: selectedLocale
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                            rel: "canonical",
                            href: meta_url
                        }),
                        (locales === null || locales === void 0 ? void 0 : locales.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                    rel: "alternate",
                                    href: (0,helper/* domainUrl */.HJ)("".concat(dbName).concat(router.asPath)),
                                    hrefLang: "x-default"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                    rel: "alternate",
                                    href: (0,helper/* domainUrl */.HJ)("".concat(dbName).concat(router.asPath)),
                                    hrefLang: defaultLangCode
                                }),
                                locales.map(function(intl) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                        rel: "alternate",
                                        href: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/").concat(intl.code).concat(router.asPath)),
                                        hrefLang: intl.code
                                    });
                                })
                            ]
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountLayout/* default */.Z, {
                    dbName: dbName,
                    breadcrumb: breadcrumb,
                    translationsData: translationsData,
                    selectedLocale: selectedLocale,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(account_AccountPageDownloadableOrders, {
                        translationsData: translationsData,
                        dbName: dbName
                    })
                })
            ]
        })
    }));
};
var __N_SSP = true;
/* harmony default export */ var downloadable_products = (DownloadableProducts);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3061,7838,3997,4531,9774,2888,179], function() { return __webpack_exec__(39989); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);